import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Link,
  Typography,
} from "@material-ui/core";
import * as consts from "../../consts";
import { State } from "../../store/state";

export default function CouponInput({ quote }) {
  const { state, dispatch } = useContext(State);
  const [couponCode, setCouponCode] = useState("");
  const [error, setError] = useState(false);
  const [totals, setTotals] = useState({
    cardCount: 0,
    cardTotal: 0,
    productionTotal: 0,
    shippingTotal: 0,
    orderAdjustments: 0,
    total: 0,
  });
  const [acceptedBookTerms, setAcceptedBookTerms] = useState(false);
  const [acceptedSweepstakesTerms, setAcceptedSweepstakesTerms] =
    useState(false);

  const [applied, setApplied] = useState(false);
  const [message, setMessage] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const useStyles = makeStyles((theme) => ({
    stepButtonSecondary: {
      margin: theme.spacing(1),
      "&:hover": { color: "#272643" },
    },
    input: {
      "& input": {
        height: "100%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    buttons: {
      [theme.breakpoints.down("sm")]: {
        justifyContent: "left",
      },
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    let storedCouponCode = sessionStorage.getItem(consts.STORAGE_COUPON_CODE);
    if (storedCouponCode) {
      let code = storedCouponCode.split("|")[0];
      let acceptedState = storedCouponCode.split("|")[1];
      setCouponCode(code);
      setMessage(`Code ${code} applied.`);
      setApplied(true);
      switch (acceptedState) {
        case "All":
          setAcceptedBookTerms(true);
          setAcceptedSweepstakesTerms(true);
          break;
        case "Book":
          setAcceptedBookTerms(true);
          break;
        case "Sweepstakes":
          setAcceptedSweepstakesTerms(true);
          break;
      }
    }
  }, []);

  useEffect(() => {
    let cardCount = 0;
    let cardTotal = 0;
    let productionTotal = 0;
    let shippingTotal = 0;
    let orderAdjustments = 0;
    state.orderAdjustments.map((orderAdjustment) => {
      if (!isNaN(orderAdjustment.amount)) {
        orderAdjustments += parseFloat(orderAdjustment.amount);
      }
    });
    let sendToMeShippingAdded = false;

    quote.map((cartItem, cartItemIndex) => {
      cardCount += cartItem.cardDetails.length;
      switch (cartItem.cardType) {
        case consts.CARD_TYPE_PLASTIC:
          if (
            cartItem.mailOption == consts.PLASTIC_TYPE_ME ||
            cartItem.mailOption == consts.PLASTIC_TYPE_NO_CARRIER
          ) {
            cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
              cardTotal += cartItem.cardValue;
              if (cardDetail.cardFee) {
                productionTotal += cardDetail.cardFee.productionFee;
                if (!sendToMeShippingAdded && cardDetailIndex == 0) {
                  sendToMeShippingAdded = true;
                  shippingTotal += cardDetail.cardFee.shippingHandling;
                }
              }
            });
          } else {
            cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
              cardTotal += cartItem.cardValue;
              if (cardDetail.cardFee) {
                productionTotal += cardDetail.cardFee.productionFee;
                shippingTotal += cardDetail.cardFee.shippingHandling;
              }
            });
          }
          break;
        case consts.CARD_TYPE_EMAIL:
          cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
          break;
        case consts.CARD_TYPE_PRINTER:
          cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
          break;
      }
    });

    let total = cardTotal + productionTotal + shippingTotal + orderAdjustments;

    setTotals({
      cardCount: cardCount,
      cardTotal: cardTotal,
      productionTotal: productionTotal,
      shippingTotal: shippingTotal,
      orderAdjustments: orderAdjustments,
      total: total,
    });
  }, [quote]);

  const renderDialog = () => {
    return (
      <Dialog
        open={showDialog}
        keepMounted
        onClose={() => {
          setCouponCode("");
          setShowDialog(false);
        }}
      >
        <DialogTitle>{"Terms & Conditions"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              variant="h3"
              style={{ fontSize: "1.2rem", marginBottom: "6px" }}
            >
              TisBest's Principles Gift with Purchase
            </Typography>
            <Typography variant="body1">
              This "Gift with Purchase Program" is open only to legal residents
              of the continental United States who have purchased a TisBest Gift
              card(s) with a value of $50 or more and who are at least 18+ years
              old at the time of entry ("Participant", or "you"). The Promotion
              is void where prohibited by law. Online store for redemptions
              opens around 12/22/23; books and t-shirts will be shipped
              beginning January 2024.
            </Typography>
            <Typography
              variant="h3"
              style={{
                fontSize: "1.2rem",
                marginTop: "16px",
                marginBottom: "6px",
              }}
            >
              TisBest's 2023 Charity Gift Card Sweepstakes
            </Typography>
            <Typography variant="body1">
              Enter for a chance to win one of three $5,000 Charity Gift Cards.
              No purchase necessary. Must be 18 and a legal resident of the
              continental United States. Odds of winning depend on the number of
              eligible entries. Void where prohibited by law.
            </Typography>
          </DialogContentText>
          <FormGroup>
            <FormControlLabel
              style={{ marginTop: "6px" }}
              control={
                <Checkbox
                  checked={acceptedBookTerms}
                  onClick={(event) => {
                    setAcceptedBookTerms(event.target.checked);
                  }}
                />
              }
              label={
                <Typography>
                  Accept{" "}
                  <Link
                    href="https://www.tisbest.org/tisbests-principles-gift-official-rules/"
                    target="_blank"
                  >
                    terms
                  </Link>{" "}
                  of Principles Gift with Purchase to receive your free gift
                  while supplies last.
                </Typography>
              }
            />
            <FormControlLabel
              style={{ marginTop: "12px" }}
              control={
                <Checkbox
                  checked={acceptedSweepstakesTerms}
                  onClick={(event) => {
                    setAcceptedSweepstakesTerms(event.target.checked);
                  }}
                />
              }
              label={
                <Typography>
                  Accept{" "}
                  <Link
                    href="https://www.tisbest.org/sweepstakes-terms-and-conditions/"
                    target="_blank"
                  >
                    terms
                  </Link>{" "}
                  of sweepstakes for a chance to win 1 of 3 $5,000 charity gift
                  cards.
                </Typography>
              }
            />
          </FormGroup>
        </DialogContent>
        <DialogActions className={classes.buttons}>
          <Button
            onClick={() => {
              sessionStorage.removeItem(consts.STORAGE_COUPON_CODE);
              setError(true);
              setMessage("Terms not accepted. Code not applied.");
              setCouponCode("");
              setShowDialog(false);
              setApplied(false);
            }}
          >
            Disagree
          </Button>
          <Button
            disabled={!acceptedBookTerms && !acceptedSweepstakesTerms}
            onClick={() => {
              sessionStorage.setItem(
                consts.STORAGE_COUPON_CODE,
                `${couponCode}|${
                  acceptedBookTerms && acceptedSweepstakesTerms
                    ? "All"
                    : acceptedBookTerms
                      ? "Book"
                      : acceptedSweepstakesTerms
                        ? "Sweepstakes"
                        : "None"
                }`
              );
              setError(false);
              setMessage(`Code ${couponCode} applied.`);
              setShowDialog(false);
              setApplied(true);
            }}
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return null;

  // return (
  //   <Grid item container xs={12} spacing={2}>
  //     {renderDialog()}
  //     <Grid item xs={12} sm={8} style={{ paddingLeft: "16px" }}>
  //       <TextField
  //         className={classes.input}
  //         fullWidth={true}
  //         InputLabelProps={{
  //           shrink: true,
  //         }}
  //         error={error || (couponCode && totals.cardTotal < 50)}
  //         helperText={
  //           applied && totals.cardTotal < 50
  //             ? "$50 card donation amount terms not met"
  //             : message
  //         }
  //         variant="outlined"
  //         label="Promo Code"
  //         value={couponCode}
  //         onChange={(event) => {
  //           setCouponCode(event.target.value.toUpperCase());
  //         }}
  //       />
  //     </Grid>
  //     <Grid item xs={12} sm={4}>
  //       {applied ? (
  //         <Button
  //           fullWidth={true}
  //           className={classes.stepButtonSecondary}
  //           variant="outlined"
  //           color="secondary"
  //           onClick={() => {
  //             sessionStorage.removeItem(consts.STORAGE_COUPON_CODE);
  //             setError(false);
  //             setMessage("");
  //             setCouponCode("");
  //             setShowDialog(false);
  //             setApplied(false);
  //           }}
  //         >
  //           Clear
  //         </Button>
  //       ) : (
  //         <Button
  //           fullWidth={true}
  //           className={classes.stepButtonSecondary}
  //           variant="outlined"
  //           color="secondary"
  //           onClick={() => {
  //             if (couponCode.toUpperCase() == "REDEFINEGIFTING") {
  //               setShowDialog(true);
  //             } else {
  //               setError(true);
  //               setMessage("Not a recognized promo code");
  //             }
  //           }}
  //         >
  //           Apply
  //         </Button>
  //       )}
  //     </Grid>
  //   </Grid>
  // );
}
